<script>
import { Radar, HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Radar,
  mixins: [reactiveProp],
  props: {
    chartData: Object,
  },
  data() {
    return {
      options: {
        tooltips: {
          enabled: true,
          displayColors: false,
          backgroundColor: "#fff",
          bodyFontColor: "#000",
          borderColor: "rgba(38, 38, 62, 0.7)",
          borderWidth: "2",
          callbacks: {
            label: (tooltipItem, data) => {
              return data.datasets[tooltipItem.datasetIndex].data[
                tooltipItem.index
              ];
            },
            title: () => {
              return null;
            },
          },
        },
        scale: {
          gridLines: {
            color: "#fff",
          },
          angleLines: { display: false },
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 5,
            stepSize: 1,
          },
          pointLabels: {
            fontColor: "#fff",
            fontSize: "14",
            fontStyle: "bold",
          },
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: true,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
